import loadDatadog from './dataDog/index';
import loadGoogleAdScript from './googleAds/googleAds';
import loadSurveyScript from './survey/medallia';

const loadExternalDependencies = async () => {
  loadSurveyScript();
  loadDatadog();
  loadGoogleAdScript();
};

export default loadExternalDependencies;
